var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-orders-list-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var brief = ref.brief;
var isLoading = ref.isLoading;
var orders = ref.orders;
var numberOfPages = ref.numberOfPages;
var currentPage = ref.currentPage;
var loadOrdersPage = ref.loadOrdersPage;
return [(brief)?_c('activation-brief-orders-list-view',{attrs:{"brief":brief,"orders":orders,"number-of-pages":numberOfPages,"current-page":currentPage,"is-loading":isLoading,"load-orders-page":loadOrdersPage}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }